var map = {
	"./big-winter-sweater/Instruction": [
		2310,
		310
	],
	"./big-winter-sweater/Instruction.tsx": [
		2310,
		310
	],
	"./big-winter-sweater/IntroPage": [
		4623,
		623
	],
	"./big-winter-sweater/IntroPage.tsx": [
		4623,
		623
	],
	"./big-winter-sweater/StitchesPage": [
		3635,
		635
	],
	"./big-winter-sweater/StitchesPage.tsx": [
		3635,
		635
	],
	"./big-winter-sweater/motifs": [
		5595,
		595
	],
	"./big-winter-sweater/motifs.ts": [
		5595,
		595
	],
	"./big-winter-sweater/pattern": [
		3731,
		731
	],
	"./big-winter-sweater/pattern.ts": [
		3731,
		731
	],
	"./big-winter-sweater/profile": [
		680,
		680
	],
	"./big-winter-sweater/profile.ts": [
		680,
		680
	],
	"./big-winter-sweater/sizes": [
		3389,
		389
	],
	"./big-winter-sweater/sizes.ts": [
		3389,
		389
	],
	"./big-winter-sweater/stitches": [
		2741,
		741
	],
	"./big-winter-sweater/stitches.tsx": [
		2741,
		741
	],
	"./juniper-vest/Instruction": [
		8167,
		167
	],
	"./juniper-vest/Instruction.tsx": [
		8167,
		167
	],
	"./juniper-vest/IntroPage": [
		4956,
		956
	],
	"./juniper-vest/IntroPage.tsx": [
		4956,
		956
	],
	"./juniper-vest/StitchesPage": [
		2122,
		122
	],
	"./juniper-vest/StitchesPage.tsx": [
		2122,
		122
	],
	"./juniper-vest/motifs": [
		8994,
		994
	],
	"./juniper-vest/motifs.ts": [
		8994,
		994
	],
	"./juniper-vest/pattern": [
		1022,
		22
	],
	"./juniper-vest/pattern.ts": [
		1022,
		22
	],
	"./juniper-vest/profile": [
		2592
	],
	"./juniper-vest/profile.ts": [
		2592
	],
	"./juniper-vest/sizes": [
		9433
	],
	"./juniper-vest/sizes.ts": [
		9433
	],
	"./juniper-vest/stitches": [
		4467,
		467
	],
	"./juniper-vest/stitches.tsx": [
		4467,
		467
	],
	"./list": [
		2836
	],
	"./list.ts": [
		2836
	],
	"./pine-pullover/BodyInstruction": [
		878,
		878
	],
	"./pine-pullover/BodyInstruction.tsx": [
		878,
		878
	],
	"./pine-pullover/Instruction": [
		4204,
		204
	],
	"./pine-pullover/Instruction.tsx": [
		4204,
		204
	],
	"./pine-pullover/IntroPage": [
		3342,
		342
	],
	"./pine-pullover/IntroPage.tsx": [
		3342,
		342
	],
	"./pine-pullover/Print": [
		3234,
		234
	],
	"./pine-pullover/Print.tsx": [
		3234,
		234
	],
	"./pine-pullover/SleeveInstruction": [
		8853,
		853
	],
	"./pine-pullover/SleeveInstruction.tsx": [
		8853,
		853
	],
	"./pine-pullover/StitchesPage": [
		6631,
		631
	],
	"./pine-pullover/StitchesPage.tsx": [
		6631,
		631
	],
	"./pine-pullover/YokeInstruction": [
		3461,
		461
	],
	"./pine-pullover/YokeInstruction.tsx": [
		3461,
		461
	],
	"./pine-pullover/pattern": [
		5876,
		876
	],
	"./pine-pullover/pattern.ts": [
		5876,
		876
	],
	"./pine-pullover/profile": [
		7472
	],
	"./pine-pullover/profile.ts": [
		7472
	],
	"./pine-pullover/sizes": [
		8220
	],
	"./pine-pullover/sizes.ts": [
		8220
	],
	"./pine-pullover/stitches": [
		9752,
		752
	],
	"./pine-pullover/stitches.tsx": [
		9752,
		752
	],
	"./salvia-cardigan/Instruction": [
		6336,
		336
	],
	"./salvia-cardigan/Instruction.tsx": [
		6336,
		336
	],
	"./salvia-cardigan/IntroPage": [
		5966,
		966
	],
	"./salvia-cardigan/IntroPage.tsx": [
		5966,
		966
	],
	"./salvia-cardigan/StitchesPage": [
		5556,
		556
	],
	"./salvia-cardigan/StitchesPage.tsx": [
		5556,
		556
	],
	"./salvia-cardigan/motifs": [
		8429,
		429
	],
	"./salvia-cardigan/motifs.ts": [
		8429,
		429
	],
	"./salvia-cardigan/pattern": [
		869,
		869
	],
	"./salvia-cardigan/pattern.ts": [
		869,
		869
	],
	"./salvia-cardigan/profile": [
		5418
	],
	"./salvia-cardigan/profile.ts": [
		5418
	],
	"./salvia-cardigan/sizes": [
		7796
	],
	"./salvia-cardigan/sizes.ts": [
		7796
	],
	"./salvia-cardigan/stitches": [
		660,
		660
	],
	"./salvia-cardigan/stitches.tsx": [
		660,
		660
	],
	"./serena-t-shirt/IntroPage": [
		9991,
		991
	],
	"./serena-t-shirt/IntroPage.tsx": [
		9991,
		991
	],
	"./serena-t-shirt/profile": [
		7701
	],
	"./serena-t-shirt/profile.ts": [
		7701
	],
	"./serena-t-shirt/sizes": [
		2151
	],
	"./serena-t-shirt/sizes.ts": [
		2151
	],
	"./tiara-vest/Instruction": [
		7317,
		317
	],
	"./tiara-vest/Instruction.tsx": [
		7317,
		317
	],
	"./tiara-vest/IntroPage": [
		9795,
		795
	],
	"./tiara-vest/IntroPage.tsx": [
		9795,
		795
	],
	"./tiara-vest/PrintPage": [
		9073,
		73
	],
	"./tiara-vest/PrintPage.tsx": [
		9073,
		73
	],
	"./tiara-vest/StitchesPage": [
		4692,
		692
	],
	"./tiara-vest/StitchesPage.tsx": [
		4692,
		692
	],
	"./tiara-vest/motifs": [
		1756,
		756
	],
	"./tiara-vest/motifs.ts": [
		1756,
		756
	],
	"./tiara-vest/pattern": [
		1560,
		560
	],
	"./tiara-vest/pattern.ts": [
		1560,
		560
	],
	"./tiara-vest/profile": [
		3304
	],
	"./tiara-vest/profile.ts": [
		3304
	],
	"./tiara-vest/sizes": [
		7953
	],
	"./tiara-vest/sizes.ts": [
		7953
	],
	"./tiara-vest/stitches": [
		470,
		470
	],
	"./tiara-vest/stitches.tsx": [
		470,
		470
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6763;
module.exports = webpackAsyncContext;